/* istanbul ignore file */
import React, { ReactElement, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { authConfig } from 'config/authConfig';
import { GrSchedules, GrBarChart } from 'react-icons/gr';
import { FiUserPlus } from 'react-icons/fi';
import {
  AuthProvider,
  AppInsightsProvider,
  UNavBar,
  UVerticalMenu
} from '@exxonmobil/uit-uda-ui-components-lib';
import { Alert } from 'antd';

import { BaselinesProvider } from 'providers/BaselinesProvider';
import { SchedulingProvider } from 'providers/SchedulingProvider';
import { IncrementalProvider } from 'providers/IncrementalProvider';
import { Router } from './Router';
import './styles/global.scss';
import styles from './App.module.scss';

const navItems = [
  {
    label: 'Scheduling',
    icon: <GrSchedules />,
    active: false,
    path: '/scheduling'
  },
  {
    label: 'Baselines',
    icon: <GrBarChart />,
    active: false,
    path: '/baselines'
  },
  {
    label: 'Increment',
    icon: <FiUserPlus />,
    active: false,
    path: '/incrementals'
  }
];

const Template = (): ReactElement => {
  return (
    <>
      <UNavBar title="AION" items={[]} />
      <div className={styles.body}>
        <UVerticalMenu items={navItems} />
        <Router />
      </div>
    </>
  );
};

export const App = (): ReactElement => {
  const errorMessage = useMemo(() => {
    return (
      <Alert
        message="Error"
        description="Something went wrong with AION"
        type="error"
      />
    );
  }, []);

  return (
    <AppInsightsProvider onError={() => errorMessage}>
      <AuthProvider authConfig={authConfig}>
        <SchedulingProvider>
          <IncrementalProvider>
            <BaselinesProvider>
              <BrowserRouter>
                <Template />
              </BrowserRouter>
            </BaselinesProvider>
          </IncrementalProvider>
        </SchedulingProvider>
      </AuthProvider>
    </AppInsightsProvider>
  );
};
